"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const wp_query_params = {
  per_page: 4
};
const wp_query = new WP_Query(wp_query_params);
function WalnutProductsConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4 animate-pulse">
            <div className="w-full aspect-square bg-muted rounded-md" />
            <div className="h-5 bg-muted rounded w-3/4 mx-auto" />
            <div className="h-4 bg-muted rounded w-1/4 mx-auto" />
          </div>)}
      </div>;
  }
  if (error || products.length === 0) {
    return <div className="py-12 text-center text-muted-foreground font-default">
        No marine components available in this category at the moment.
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
      {products.map((product, i) => <div key={product.id} data-index={i} className="group flex flex-col bg-card border border-border/50 rounded-md shadow-sm transition-all duration-300 hover:shadow-lg hover:scale-[1.02]">
          <Link to={product.link} className="relative block w-full aspect-square mb-6 overflow-hidden rounded-t-md bg-muted">
            {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center bg-muted">
                <span className="text-sm text-muted-foreground font-default">OEM Image Pending</span>
              </div>}
            {}
            <div className="absolute top-3 right-3 bg-white/90 p-1 rounded-sm border border-border shadow-xs">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686328/img/marine_part_barcode.png" alt="SKU Label" className="w-10 h-10 opacity-80" />
            </div>
          </Link>
          
          <div className="flex flex-col flex-grow text-center px-4 pb-6">
            <Link to={product.link} className="mb-1">
              <h3 className="text-lg font-default font-bold text-foreground transition-colors hover:text-primary uppercase tracking-tight">
                {product.title}
              </h3>
            </Link>
            
            <div className="mb-3">
              <span className="inline-block px-3 py-1 text-[10px] font-mono font-bold bg-primary text-primary-foreground rounded-sm uppercase tracking-wider">
                Compatible with Yamaha Outboards
              </span>
            </div>

            {product.price !== undefined && <p className="text-muted-foreground font-mono text-sm mb-4">
                REF: ALT-{product.id}-MAR
              </p>}
            
            <div className="mt-auto opacity-0 transition-opacity duration-300 group-hover:opacity-100 focus-within:opacity-100 sm:opacity-100">
              <AddToCartButton productId={product.id} className="w-full" buttonClassName="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-default font-semibold rounded-md transition-colors" text="Quick Inquiry" showQuantity={false} />
            </div>
          </div>
        </div>)}
    </div>;
}
export default function FeaturedOemComponents() {
  return <section data-section-id="223068" id="featured-oem-components" className="py-24 bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-16 text-center">
          <h2 className="mb-4 text-4xl md:text-5xl font-default font-bold text-primary uppercase tracking-tighter">
            Featured OEM Components
          </h2>
          <p className="max-w-2xl mx-auto text-muted-foreground font-default text-lg">
            Precision-engineered marine spare parts built to Japanese OEM standards. Trusted performance for professional maritime maintenance.
          </p>
        </div>
        
        <EcommerceProductsProvider wp_query={{
        per_page: 4
      }}>
          <WalnutProductsConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}